(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="hero-slideshow-"]').forEach(function (root) {
    var slides = root.querySelectorAll('.hero-slide');
    var dots = root.querySelectorAll('.hero-slideshow-dot');
    var prevBtn = root.querySelector('.hero-slideshow-arrow.prev');
    var nextBtn = root.querySelector('.hero-slideshow-arrow.next');
    if (slides.length < 2) return;

    var current = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
});

  } catch(e) { console.error(e); }
})();
})();
